import { render, staticRenderFns } from "./CreditNoteWidget.vue?vue&type=template&id=37c85f54&scoped=true&"
import script from "./CreditNoteWidget.vue?vue&type=script&lang=ts&"
export * from "./CreditNoteWidget.vue?vue&type=script&lang=ts&"
import style0 from "./CreditNoteWidget.vue?vue&type=style&index=0&id=37c85f54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c85f54",
  null
  
)

export default component.exports